export class SearchTypeConstant {
    static readonly CAR = 'CAR';
    static readonly CARSMALL = 'CAR-SMALL';
    static readonly MOTORCYCLE = 'MOTORCYCLE';
    static readonly TRUCK = 'TRUCK';
    static readonly BUS = 'BUS';
    static readonly IMPLEMENT = 'IMPLEMENT';
}